import Modal from "components/Modal";
import path from "constants/path";
import useLabels from "hooks/useLabels";
import { useRouter } from "next/router";

type PropsType = {
  open?: boolean;
  onClose: () => void;
};

/**
 * @component CannotSubscribeModal
 * @description Component for show no edu email modal
 * @example
 * return (
 *   <CannotSubscribeModal
 *    open={true}
 *    onClose={fn}
 *   />
 * )
 */
export const CannotSubscribeModal = ({ open, onClose }: PropsType) => {
  const router = useRouter();
  const [pricingLabels] = useLabels("screens.pricing");

  const handleClickManagePlan = () => {
    router.push(path.SUBSCRIPTION);
    onClose();
  };

  const handleClickSupport = () => {
    if (window && window.Intercom) {
      window.Intercom("show");
    }

    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={pricingLabels["cannot-subsribe-modal-title"]}
      onButtonClicked={handleClickManagePlan}
      buttonText={pricingLabels["manage-plan"]}
      subtitle={
        <div className="mr-20">
          <span> {pricingLabels["cannot-subsribe-modal-subtitle-1"]}</span>
          <button
            className="underline text-accent-fg-base"
            onClick={handleClickSupport}
          >
            {pricingLabels["contact-support"]}
          </button>
          <span>{pricingLabels["cannot-subsribe-modal-subtitle-2"]}</span>
        </div>
      }
    ></Modal>
  );
};
